import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Servicios from "./components/Servicios/Servicios";
import InfoServicios from "./components/InfoServicios/InfoServicios";
import Filosofia from "./components/Filosofia/Filosofia";
import Faq from "./components/Faq/Faq";
import Galeria from "./components/Galeria/Galeria";
import SobreCata from "./components/SobreCata/SobreCata";
import Login from "./components/Login/Login";
import RestablecerPassword from "./components/Login/RestablecerPassword";
import Footer from "./components/Footer/Footer";
import Reservas from "./components/Reservas/Reservas";
import MisTurnos from "./components/Reservas/MisTurnos";
import Loader from "./components/Loader/Loader";
import RedesSociales from "./components/RedesSociales/WhatsApp";
import Admin from "./components/Admin/Admin";
import Mapa from "./components/Mapa/Mapa";
import TransicionColor from "./components/Animaciones/TransicionColor";
import ModalReserva from "./components/Modal/ModalReserva";
import Privacidad from "./components/Legal/Privacidad";
import Terminos from "./components/Legal/Terminos";
import "./App.css";

function PaginaAnimada({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
}

function ContenidoApp({ seccionActiva, setSeccionActiva, modalAbierto, setModalAbierto }) {
  const location = useLocation();
  const _esAdmin = location.pathname.startsWith("/admin");
  const [infoServiciosAbierto, setInfoServiciosAbierto] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {!_esAdmin && <RedesSociales />}
      <ModalReserva abierto={modalAbierto} onCerrar={() => setModalAbierto(false)} />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PaginaAnimada>
                <div className="app-contenedor">
                  <Navbar
                    seccionActiva={seccionActiva}
                    setSeccionActiva={setSeccionActiva}
                    onAbrirServicios={() => setInfoServiciosAbierto(true)}
                  />
                <Hero onReservar={() => setModalAbierto(true)} />
<Galeria />
<TransicionColor desde="var(--gris-claro)" hasta="var(--rosa-palido)" />
<InfoServicios
  abierto={infoServiciosAbierto}
  onAbrir={() => setInfoServiciosAbierto(true)}
  onCerrar={() => setInfoServiciosAbierto(false)}
/>
<Servicios onReservar={() => setModalAbierto(true)} />
<Filosofia />
<SobreCata />
<TransicionColor desde="var(--blanco)" hasta="var(--gris-claro)" compacta />
<Faq />
<TransicionColor desde="var(--gris-claro)" hasta="var(--blanco)" compacta />
<Mapa />
                  <Footer />
                </div>
              </PaginaAnimada>
            }
          />
          <Route path="/login" element={<PaginaAnimada><Login /></PaginaAnimada>} />
          <Route path="/resetear-password" element={<PaginaAnimada><RestablecerPassword /></PaginaAnimada>} />
          <Route path="/reservar" element={<PaginaAnimada><Reservas /></PaginaAnimada>} />
          <Route path="/mis-turnos" element={<PaginaAnimada><MisTurnos /></PaginaAnimada>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacidad" element={<PaginaAnimada><Privacidad /></PaginaAnimada>} />
          <Route path="/terminos" element={<PaginaAnimada><Terminos /></PaginaAnimada>} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

function App() {
  const [seccionActiva, setSeccionActiva] = useState("inicio");
  const [cargando, setCargando] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);

  return (
    <Router>
      {cargando && <Loader onTerminado={() => setCargando(false)} />}
      <ContenidoApp
        seccionActiva={seccionActiva}
        setSeccionActiva={setSeccionActiva}
        modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto}
      />
    </Router>
  );
}

export default App;